import axios from 'axios';

import { FIRST_PAGE } from '../../services/pagination-service';
import { createCancelablePromise } from '../../services/promises/create-cancelable-promise';

export const getExternalInventory = ({ connectionIds = [], pageNumber = FIRST_PAGE, pageSize, searchTerm }) => {
  const page = {
    pageNumber,
    pageSize,
  };

  const payload = {
    page,
    connectionIds,
    filter: searchTerm,
  };

  const requestPromise = axios.post('/externalInventoryGrid', payload).then((res) => {
    return res?.data ?? {};
  });

  return createCancelablePromise(requestPromise);
};
